module.exports = __webpack_public_path__ + "static/img/dia-del-nino-3.3fa55cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/dia-del-nino-3.jpg
// module id = mSfc
// module chunks = 1